<template>
    <el-popconfirm
        :confirmButtonText='(translate) ? $ml.get(confirmText): confirmText'
        :cancelButtonText='(translate) ? $ml.get(cancelText): cancelText'
        :icon="popIcon"
        :iconColor="iconColor"
        :confirmButtonType="confirmButtonType"
        :cancelButtonType="cancelButtonType"
        :hideIcon="hideIcon"
        @confirm="onConfirm"
        @cancel="onCancel"
        :title='(translate) ? $ml.get(title): title'>
        <el-button slot="reference" :loading='loading' :round='round' :icon='icon' :size='fieldSize' :type='type' class='devegram-input-confirm-button-field'>
            {{(translate) ? $ml.get(text): text}}
        </el-button>
    </el-popconfirm>
</template>

<script>
    export default {
        props: {
            onConfirm: {
                required: true,
                type: Function
            },
            onCancel: {
                required: false,
                default: () => {
                    return new Function
                }
            },
            confirmButtonType: {
                required: false,
                default: 'primary',
            },
            cancelButtonType: {
                required: false,
                default: 'text',
            },
            hideIcon: {
                required: false,
                default: false
            },
            iconColor: {
                required: false,
                default: '#5eabae'
            },
            title: {
                required: false,
                default: 'Are You Sure ?'
            },
            confirmText: {
                required: false,
                default: 'Yes'
            },
            cancelText: {
                required: false,
                default: 'No'
            },
            fieldSize: {
                required: false,
                defafult: 'small'
            },
            loading: {
                required: false,
                defafult: false
            },
            round: {
                required: false,
                defafult: false
            },
            text: {
                required: true
            },
            icon: {
                required: false
            },
            popIcon: {
                required: false,
                default: 'el-icon-info'
            },
            type: {
                required: false,
                default: 'info'
            },
            translate: {
                required: false,
                default: true
            }
        }
    }
</script>
